import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, ViewController, AlertController } from 'ionic-angular';
import { 
  Input,
  OnInit } from "@angular/core";
import { APIServiceProvider } from '../../common/services/api.service';



/**
 * Generated class for the PaymentInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-payment-info',
  templateUrl: 'payment-info.html',
})
export class PaymentInfoPage implements OnInit {

  @Input() order : any = {};
  list: any = [];

   public deleteapi: any = false;

 constructor(
  public modalCtrl: ModalController,
  private apiService: APIServiceProvider,
  public viewCtrl:ViewController,
   private alertController: AlertController,
  public navParam: NavParams
) { }

  ngOnInit() { 
      this.list = []; 
      this.getPaymentTransactions(this.navParam.data.orderDetails.order_payment_detail.opportunity_id);
}
dismiss() {
  this.viewCtrl.dismiss();
}

deleteTransaction(item){
     
    const alert = this.alertController.create({
      title: 'Confirmation',
      message: "<p>Are you sure you want to delete</p>",
      buttons: [
        {
          text: 'Remove',
          handler: () => {
            this.deleteTrans(item);
          }
        },
        {text: 'Cancel',role: 'cancel'} 
      ]
    });
    alert.present();
  }

 
  deleteTrans(item) {
        this.deleteapi = true;

        this.apiService.post(`order/finance/delete-finance-payment`, {'payment_txn_id': item.payment_txn_id})
        .subscribe(response => { 

                this.deleteapi = false;

                    if (response['data']['status'] == 'success') {
                        this.getPaymentTransactions(this.navParam.data.orderDetails.order_payment_detail.opportunity_id);
                    } else { 
                      this.viewCtrl.dismiss();
                    }
                },
                err => {
                    this.viewCtrl.dismiss();
                }
            );
    }

getPaymentTransactions(opportunity_id) {
  this.apiService.get(`order/finance/get-payment-history/${opportunity_id}`)
  .subscribe(data => {
        
              if (data['data']['status'] == 'success') {
                  this.list = [];
                  this.list = data['data']['history_data']; 
              } else {
              this.list = [];
              this.viewCtrl.dismiss();
              }
          },
          err => {
            this.viewCtrl.dismiss();
          }
      );
  }

} 



// WEBPACK FOOTER //
// ./src/modals/payment-info/payment-info.ts